import { useTranslation } from "react-i18next"
import { Button, Icon } from "@nexus/ui"

/** Read-only refining state — shows a note recorded with an earlier rejection; undo from the footer. */
export function RefiningBar({
  note,
  isBusy,
  onCancelEdit,
}: {
  note: string
  isBusy: boolean
  onCancelEdit?: () => void
}) {
  const { t } = useTranslation()
  return (
    <div className="flex flex-col gap-2.5">
      <div className="flex items-start gap-2 rounded-md border border-warning-border bg-warning-subtle px-2.5 py-2">
        <Icon
          name="pencil"
          size="sm"
          className="mt-0.5 shrink-0 text-warning-subtle-foreground"
        />
        <div className="min-w-0">
          <p className="text-xs font-semibold text-warning-subtle-foreground">
            {t(
              "personas.onboarding.review.changeSavedTitle",
              "Change saved · applies on next re-run",
            )}
          </p>
          <p className="mt-0.5 truncate text-xs leading-snug text-foreground">
            {t("personas.onboarding.review.changeSavedNote", {
              defaultValue: "“{{note}}”",
              note,
            })}
          </p>
        </div>
      </div>
      {onCancelEdit && (
        <Button
          type="button"
          variant="outline"
          size="default"
          className="min-w-0 flex-1"
          disabled={isBusy}
          iconStart="x"
          onClick={onCancelEdit}
        >
          {t("personas.onboarding.review.cancelEdit", "Cancel edit")}
        </Button>
      )}
    </div>
  )
}
